import { render } from "./learningCenterFeedbackTab.vue?vue&type=template&id=ef9db2d4"
import script from "./learningCenterFeedbackTab.vue?vue&type=script&lang=js"
export * from "./learningCenterFeedbackTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__